<template>
  <div>
    <v-dialog
      v-model="showModal"
      overlay-color="white"
      :overlay-opacity="0.9"
      persistent
      max-width="560px"
    >
      <v-tooltip
        v-model="showHelpTooltip"
        right
        color="primary"
        max-width="20vw"
      >
        <template #activator>
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="pl-0 mb-8">
                    <h2 class="color-primary">
                      <slot name="title"></slot>
                    </h2>
                  </v-col>
                </v-row>
                <slot name="body" :form-data="formData" />
                <slot name="infobox" />
              </v-container>
            </v-card-text>
            <v-card-actions class="d-flex justify-space-between">
              <v-btn
                outlined
                color="primary"
                class="ml-4"
                @click="showModal = false"
              >
                {{ $t('baseOverwriteModal.abort') }}
              </v-btn>
              <v-btn
                v-if="showResetBtn"
                outlined
                color="warning"
                @click="reset"
              >
                {{ $t('baseOverwriteModal.reset') }} ({{ resetValue }})
              </v-btn>
              <v-btn
                :disabled="!submittable"
                outlined
                color="error"
                class="mr-4"
                @click="overwrite"
              >
                {{ $t('baseOverwriteModal.overwrite') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
        <span>
          <slot name="help"> </slot>
        </span>
      </v-tooltip>
    </v-dialog>
    <v-snackbar v-model="snackBar" color="warning" :timeout="1500" top right>
      {{ $t('baseOverwriteModal.notPossible') }}
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ChartOverwriteModalBase',

  props: {
    /**
     * the data needed in the slots
     */
    formData: {
      required: true,
      type: Object,
    },
    /**
     * an identifier to decide if
     * we have to open the modal
     * based on a watcher
     */
    modalId: {
      required: true,
      type: [String, Number],
    },
    /**
     * the date of the day
     * which is being overwritten
     */
    editDate: {
      require: true,
      type: [String, Date],
      default: new Date(),
    },
    submittable: {
      require: false,
      type: Boolean,
      default: true,
    },
    showResetBtn: {
      require: false,
      type: Boolean,
      default: false,
    },
    /**
     * the original value we are going
     * to reset to
     */
    resetValue: {
      require: false,
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showModal: false,
      snackBar: false,
      showHelpTooltip: false,
    }
  },

  methods: {
    async overwrite() {
      this.$emit('overwrite')
      this.showModal = false
    },
    async reset() {
      this.$emit('reset')
      this.showModal = false
    },
    /**
     * open the modal only for future dates
     */
    openModal() {
      if (moment(this.editDate).isSameOrAfter(moment())) {
        this.showModal = true
      } else {
        this.snackBar = true
      }
    },
    /**
     * open the tooltip used
     * for help texts
     */
    openHelpTooltip(value = true) {
      this.showHelpTooltip = value
    },
  },
}
</script>

<style lang="scss" scoped>
>>> .v-dialog {
  border: none;
  .v-card {
    padding: 1rem;
  }
}

.color-primary {
  color: var(--v-primary-base);
}
</style>
